(function () {
  'use strict';

  var GALLERIES = [
    {
      gallery: '.lmh-gallery',
      main: '.lmh-main',
      thumbs: '.lmh-thumbs img',
      activeClass: 'lmh-tactive'
    },
    {
      gallery: '[data-mask-gallery]',
      main: '[data-mask-main]',
      thumbs: '[data-mask-thumb]',
      activeClass: 'is-active'
    },
    {
      gallery: '[data-redsky-gallery]',
      main: '[data-redsky-main]',
      thumbs: '[data-redsky-thumb]',
      activeClass: 'is-active'
    }
  ];

  function visibleThumbs(gallery, selector) {
    return Array.prototype.filter.call(gallery.querySelectorAll(selector), function (thumb) {
      return !thumb.hidden && thumb.getAttribute('aria-hidden') !== 'true' && window.getComputedStyle(thumb).display !== 'none';
    });
  }

  function revealThumb(thumb) {
    var rail = thumb.parentElement;
    if (!rail) return;

    var railBox = rail.getBoundingClientRect();
    var thumbBox = thumb.getBoundingClientRect();
    var options = { behavior: 'smooth' };

    if (rail.scrollWidth > rail.clientWidth) {
      if (thumbBox.left < railBox.left) options.left = rail.scrollLeft - (railBox.left - thumbBox.left);
      if (thumbBox.right > railBox.right) options.left = rail.scrollLeft + (thumbBox.right - railBox.right);
    }

    if (rail.scrollHeight > rail.clientHeight) {
      if (thumbBox.top < railBox.top) options.top = rail.scrollTop - (railBox.top - thumbBox.top);
      if (thumbBox.bottom > railBox.bottom) options.top = rail.scrollTop + (thumbBox.bottom - railBox.bottom);
    }

    if (options.left !== undefined || options.top !== undefined) rail.scrollTo(options);
  }

  function bindGallery(gallery, config) {
    if (gallery.dataset.luscentSwipeReady === 'true') return;

    var main = gallery.querySelector(config.main);
    if (!main) return;

    gallery.dataset.luscentSwipeReady = 'true';
    main.draggable = false;
    main.style.touchAction = 'pan-y';
    main.style.userSelect = 'none';
    main.style.webkitUserDrag = 'none';

    var pointerId = null;
    var startX = 0;
    var startY = 0;

    function reset() {
      pointerId = null;
      startX = 0;
      startY = 0;
    }

    main.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    main.addEventListener('pointerdown', function (event) {
      if (!event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
    });

    main.addEventListener('pointerup', function (event) {
      if (pointerId === null || event.pointerId !== pointerId) return;

      var deltaX = event.clientX - startX;
      var deltaY = event.clientY - startY;
      reset();

      if (Math.abs(deltaX) < 44 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.25) return;

      var thumbs = visibleThumbs(gallery, config.thumbs);
      if (thumbs.length < 2) return;

      var activeIndex = thumbs.findIndex(function (thumb) {
        return thumb.classList.contains(config.activeClass);
      });
      if (activeIndex < 0) activeIndex = 0;

      var nextIndex = deltaX < 0 ? activeIndex + 1 : activeIndex - 1;
      nextIndex = Math.max(0, Math.min(thumbs.length - 1, nextIndex));
      if (nextIndex === activeIndex) return;

      thumbs[nextIndex].click();
      revealThumb(thumbs[nextIndex]);
    });

    main.addEventListener('pointercancel', reset);
  }

  function init(scope) {
    GALLERIES.forEach(function (config) {
      var galleries = scope.matches && scope.matches(config.gallery)
        ? [scope]
        : scope.querySelectorAll(config.gallery);

      Array.prototype.forEach.call(galleries, function (gallery) {
        bindGallery(gallery, config);
      });
    });
  }

  function start() {
    init(document);
    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
